// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"dbf6d7f2","216":"6e1bd95b","632":"5228811f","641":"03681b19","782":"9efd8dc1","860":"98244ebf","901":"67960021","905":"bbd8c7a1"}[chunkId] + ".chunk.js";
};